import { render } from "./NewGenerateFormPage.vue?vue&type=template&id=fca17dc6"
import script from "./NewGenerateFormPage.vue?vue&type=script&lang=js"
export * from "./NewGenerateFormPage.vue?vue&type=script&lang=js"

import "./NewGenerateFormPage.vue?vue&type=style&index=0&id=fca17dc6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__